import { Typography } from '@mui/material'

export const AirSegmentIcon = ({ icon, text, style }) => (
  <div className='air_segment'>
    <div style={style}>{icon}</div>
    <Typography
      variant='h8'
      component='div'
      style={{
        margin: '0 15px 0 5px',
        fontWeight: '600',
        width: '70px',
      }}
    >
      {text}
    </Typography>
  </div>
)
